export default "Exonération CSPE (accise électricité) — Taux réduits & remboursement | Solution Éco France";
